
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import SquareShadowBox from "@/components/SquareShadowBox.vue";
import VueQRCodeComponent from "vue-qrcode-component";
import DocValidations from "@/models/Sobrevivencia/Documentos/DocValidations";
import GlobalConfig from '@/GlobalConfig';
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import VueHtml2pdf from "vue-html2pdf";
import BenefactorsRequiredDocuments from "./BenefactorsRequiredDocuments.vue";
@Component({
  components: { SquareShadowBox, VueQRCodeComponent,VueHtml2pdf,BenefactorsRequiredDocuments },
})
export default class Validacion extends Vue {
  @Prop({ default: false }) isValid: boolean;
  @Prop({ default: [] }) benefactors: Benefactor[];
  @Prop({ default: [] }) generalDocs: BenefactorDocument[];
  public documentos : Array<string> = new Array<string>();
  public documentsToshow: Array<{value:string,show:boolean,index:number}> = new Array<{value:string,show:boolean,index:number}>();
  public indMistrarMas:boolean=true;


  mounted(){
    //  this.fillDocuments(); 
  }
  
  public goToOficinas() {
    window.location.href =
      GlobalConfig.PUBLIC_WEB_URL + "/empresas/vias-de-contacto/";
  }
  @Watch("benefactors")
  public fillDocuments(){
   if(this.documentsToshow.length <=0 ){ 
    var index =this.documentsToshow.length;
    this.benefactors.forEach((benefactor)=>{
      benefactor.documents.forEach((document)=>{ 
        this.documentsToshow.push({ value:document.descDocumento +" - " + benefactor.primerNombre + " " + benefactor.primerApellido, show:index<=4?true:false,index:index}  )
        index = index+1;  
      })
      
    })

    this.generalDocs.forEach((document)=>{
         
        this.documentsToshow.push({ value:document.descDocumento  , show:index<=4?true:false,index:index}  )
        index = index+1; 
    })
   }
  }
  
  public mostrarMas(){
    this.documentsToshow.forEach((element)=>{
      element.show = true;
    })
    this.indMistrarMas = false
  }

  public mostrarMenos(){
    this.indMistrarMas= true;
    this.documentsToshow.forEach((element)=>{
      if(element.index >4){
        element.show = false;
      }
    })
  }

  get showButtons(){
    return this.documentsToshow.length>5
  }
  get numSolicitud(){
    if(this.benefactors.length>0){
      return this.benefactors[0].numPreSolicitud;
    }
  }
  generateReport() {
    (this.$refs.html2Pdf as any).generatePdf();
  }

  get
}
